import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const DesignToolsSection = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="order-2 md:order-1">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="rounded-lg overflow-hidden shadow-lg">
                  <img 
                    src="https://storage.googleapis.com/fenado-ai-farm-public/generated/6e6751c8-8d0a-4d08-bc06-4c6a7a77b1e9.webp"
                    alt="Canva Design"
                    className="w-full h-auto"
                  />
                </div>
                <div className="rounded-lg overflow-hidden shadow-lg">
                  <img 
                    src="https://storage.googleapis.com/fenado-ai-farm-public/generated/7a3e9f96-8c70-4bb7-9d74-a5d2b8be8fe7.webp"
                    alt="Pinterest Design"
                    className="w-full h-auto"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="rounded-lg overflow-hidden shadow-lg">
                  <img 
                    src="https://storage.googleapis.com/fenado-ai-farm-public/generated/1de9661d-5f04-4c60-8a04-d30f9df9bff7.webp"
                    alt="Adobe Express"
                    className="w-full h-auto"
                  />
                </div>
                <div className="rounded-lg overflow-hidden shadow-lg">
                  <img 
                    src="https://storage.googleapis.com/fenado-ai-farm-public/generated/293ecf9e-6809-4f5c-a7f6-92e5366c6c85.webp"
                    alt="YouTube Design"
                    className="w-full h-auto"
                  />
                </div>
              </div>
            </div>
          </div>
          
          <div className="space-y-6 order-1 md:order-2">
            <h2 className="text-3xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              Ferramentas de Design para Criadores de Conteúdo
            </h2>
            <p className="text-muted-foreground">
              Crie designs profissionais, vídeos e animações para suas redes sociais, blogs e canais usando Canva e Adobe Express. Perfeito para Pinterest, YouTube e muito mais.
            </p>
            <ul className="space-y-2">
              <li className="flex items-start">
                <span className="bg-primary/20 text-primary p-1 rounded-full mr-2">✓</span>
                <span>Templates prontos para posts, vídeos e animações</span>
              </li>
              <li className="flex items-start">
                <span className="bg-primary/20 text-primary p-1 rounded-full mr-2">✓</span>
                <span>Tutoriais passo a passo para criar designs incríveis</span>
              </li>
              <li className="flex items-start">
                <span className="bg-primary/20 text-primary p-1 rounded-full mr-2">✓</span>
                <span>Integração com Pinterest, YouTube e outras plataformas</span>
              </li>
              <li className="flex items-start">
                <span className="bg-primary/20 text-primary p-1 rounded-full mr-2">✓</span>
                <span>Crie conteúdo visual profissional sem conhecimento técnico</span>
              </li>
            </ul>
            <div className="flex flex-wrap gap-4">
              <Button 
                onClick={() => navigate("/design-tools")}
                className="bg-primary text-primary-foreground hover:bg-primary/90"
              >
                Explorar ferramentas <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              <Button 
                variant="outline" 
                onClick={() => window.open("https://www.canva.com/download/windows/", "_blank")}
              >
                Baixar Canva
              </Button>
              <Button 
                variant="outline" 
                onClick={() => window.open("https://www.adobe.com/express/create/animation/youtube", "_blank")}
              >
                Adobe Express
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DesignToolsSection;